import React, { useEffect, useState } from 'react'
import instance from '../../Utils/api';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useGlobalContext } from '../../context/Context';
import Topbar from '../layouts/Topbar';
import PageHeader from '../components/PageHeader';
import SubHeader from '../components/SubHeader';
import Catalogueorder from '../../Admin/components/Catalogue_order';
import Customizedorder from '../components/Customize_order';
import { Button, Checkbox, Typography } from '@mui/material';
import Image from "../../Utils/getImage.js";
import Delete from "../../User/assets/icons/delete.svg";
import Ordereduser from '../components/Ordered_user.jsx';
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Addtocart = () => {
    const [customer, setCustomer] = useState('');
    const navigate = useNavigate();
    const title = { name: `Customer Cart (${customer?.name})`, subheading: "Follow up with the Customer", search: "" }
    const { customerId } = useParams();
    const [cartItems, setCartItems] = useState([]);
    const { loading, setLoading } = useGlobalContext();
    const { openDialog, setOpenDialog } = useGlobalContext();
    const [getCartItems, setgetCartItems] = useState(false);
    const [openDialogcatalogue, setOpenDialogcatalogue] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showOrderPage, setShowOrderPage] = useState(false);
    const [consultation, setConsultation] = useSearchParams();
    const consultationId = consultation.get('consultation_id');
    const [cartLoading, setCartLoading] = useState(true);

    //fetchCartItems
    const fetchCartItems = async () => {
        try {
            setLoading(true);
            const response = await instance.get(`/Cart/getCart?customer_id=${customerId}`)
            setCartItems(response?.data?.data?.items);
        } catch (error) {
            console.log("error to fetch Customer:", error.message)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCartItems();
        setgetCartItems(false)
    }, [customerId, getCartItems]);

    const getCustomerbyid = async () => {
        try {
            const response = await instance.get(`/Customer/getCustomerById?admin_id=${customerId}`);
            setCustomer(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        getCustomerbyid();
    }, []);

    const handleQuantityChange = (itemId, action) => {
        setCartLoading(true);
        const updatedCart = cartItems.map(item => {
            if (item._id === itemId) {
                const newQuantity = action === 'increase' ? item.quantity + 1 : Math.max(1, item.quantity - 1);
                updateItemQuantity(itemId, newQuantity);
                return { ...item, quantity: newQuantity };
            }
            return item;
        });
        setCartItems(updatedCart);
    };

    //updateItemQuantity function
    const updateItemQuantity = async (itemId, quantity) => {
        try {
            await instance.patch(`/Cart/updateItemQuantity?customer_id=${customerId}&item_id=${itemId}&quantity=${quantity}`)
        } catch (error) {
            console.log(error.message)
        } finally {
            setCartLoading(false);
        }
    }

    // Handle "Select All" checkbox
    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allItemIds = cartItems.map(item => item._id);
            setSelectedItems(allItemIds);
        } else {
            setSelectedItems([]);
        }
    };

    // Handle Individual Checkbox Selection
    const handleSelectItem = (itemId) => {
        if (selectedItems.includes(itemId)) {
            setSelectedItems(selectedItems.filter(id => id !== itemId));
        } else {
            setSelectedItems([...selectedItems, itemId]);
        }
    };

    //Handle deleteitem
    const handleDeleteItem = async (item) => {
        setCartLoading(true);
        try {
            const response = await instance.delete(`/Cart/removeFromCart?customer_id=${customerId}&item_id=${item._id}`);
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                setgetCartItems(true)
            } else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setCartLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Topbar />
            <section className='admin-catalogue'>
                <PageHeader
                    files={false}
                    title={title}
                    search={"false"}
                    showButton={true}
                    isAddToCartPage={true}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    setOpenDialogcatalogue={setOpenDialogcatalogue}
                    openDialogcatalogue={openDialogcatalogue}
                    btn={"Add to catalogue order"}
                    btn2={"Add to customize order"}
                />
                <SubHeader
                    filter={false}
                    isVisible={false}
                />
                {loading ?
                    <CircularProgress />
                    :
                    <React.Fragment>
                        {showOrderPage ?
                            (
                                <>
                                    <Ordereduser
                                        selectedItems={selectedItems}
                                        setShowOrderPage={setShowOrderPage}
                                        customerId={customerId}
                                        consultationId={consultationId}
                                    />
                                </>
                            ) : (
                                <>
                               
                                    <div className='cart-title'>
                                        <div className='cart-title-left'>
                                            <Button startIcon={<KeyboardBackspaceIcon />} onClick={() => navigate(-1)}>
                                                Back
                                            </Button>
                                        </div>
                                        <div className='cart-title-text'>
                                            <Typography variant='h4'>My Cart</Typography>
                                        </div>
                                        <div className='select-cart-all'>
                                            <Typography variant='h5'>
                                                {selectedItems?.length === cartItems?.length && cartItems?.length > 0 ? "Deselect All" : "Select All"}
                                            </Typography>
                                            <Checkbox
                                                checked={selectedItems?.length === cartItems?.length && cartItems?.length > 0}
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    <div className="admin-cart">
                                        {cartItems?.length > 0 ? (
                                            cartItems.map((item, index) => (
                                                <div className="admin-cart-details" key={index}>
                                                    <div className="item-checked">
                                                        <Checkbox
                                                            checked={selectedItems.includes(item._id)}
                                                            onChange={(e) => handleSelectItem(item._id, e.target.checked)}
                                                        />
                                                    </div>
                                                    <div className="product-image">
                                                        <Image src={item?.design_id?.picture ? item?.design_id?.picture[0] : item?.design_id?.picture} alt="picture" width={200} height={185} />
                                                    </div>
                                                    <div className="product-description">
                                                        <div className="product-content">
                                                            <Typography><span>Design Kind</span> : {item?.design_kind === "Design" ? "CatalogueDesign" : "CustomDesign"}</Typography>
                                                            <Typography><span>Design Name</span> : {item?.design_id?.name ? item?.design_id?.name : item?.name}</Typography>
                                                            <Typography><span>Price</span> : {item?.design_id?.price ? item?.design_id?.price : item?.price}</Typography>
                                                            <Typography><span>Size</span> : {item?.design_id?.size ? item?.design_id?.size : item?.size}</Typography>
                                                            <Typography><span>Description</span> : {item?.design_id?.description.length <= 100 ? item?.design_id?.description : `${item?.design_id?.description.slice(0, 100)}...`}</Typography>

                                                            <Typography><span>Quantity</span> : {item?.quantity}</Typography>
                                                        </div>
                                                        <div className="product_remove">
                                                            <Button
                                                                endIcon={<img src={Delete} alt="Delete" />}
                                                                onClick={() => handleDeleteItem(item)}
                                                            >
                                                                Delete
                                                            </Button>
                                                            <div className='quantity-increase'>
                                                                <Button onClick={() => handleQuantityChange(item._id, 'decrease')}>-</Button>
                                                                <span>{item?.quantity}</span>
                                                                <Button onClick={() => handleQuantityChange(item._id, 'increase')}>+</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className='no-cart-items'>
                                                <Typography>No items in your cart.</Typography>
                                            </div>
                                        )}
                                    </div>
                                    <div className='order-btn'>
                                        <div className="ordered-details">
                                            <div className="ordered-content">
                                                <Typography variant="h5">Order details</Typography>
                                                <span className="order-separate"></span>
                                                <Typography variant="h6">
                                                    Total <span>{selectedItems?.length} items</span>
                                                </Typography>
                                                <Button
                                                    onClick={() => {
                                                        setShowOrderPage(true);
                                                        const selectedItemsDetails = cartItems.filter(item => selectedItems.includes(item._id));
                                                        setSelectedItems(selectedItemsDetails);

                                                    }}
                                                    disabled={selectedItems?.length === 0}
                                                    sx={{
                                                        backgroundColor: selectedItems?.length === 0 ? 'lightgray' : '#e37b00',
                                                    }}
                                                >
                                                    Place Your Order
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </React.Fragment>
                }
                <Catalogueorder
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    setgetCartItems={setgetCartItems}
                    customerId={customerId}
                />
                <Customizedorder
                    setOpenDialogcatalogue={setOpenDialogcatalogue}
                    openDialogcatalogue={openDialogcatalogue}
                    customerId={customerId}
                    setgetCartItems={setgetCartItems}

                />
            </section >
        </React.Fragment >
    )
}

export default Addtocart;
